module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[35]34.b255de2.woff2";